/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Purchased_BtnInputs */

const en_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchased`)
};

const ar_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم الشراء`)
};

const de_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekauft`)
};

const es_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprado`)
};

const fr_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acheté`)
};

const it_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquistato`)
};

const ja_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入済`)
};

const ko_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매 완료`)
};

const pt_br_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprado`)
};

const ru_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приобретено`)
};

const th_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซื้อแล้ว`)
};

const tr_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satın Alındı`)
};

const zh_cn_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已购买`)
};

const zh_tw_purchased_btn = /** @type {(inputs: Purchased_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已購買`)
};

/**
* | output |
* | --- |
* | "Purchased" |
*
* @param {Purchased_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const purchased_btn = /** @type {((inputs?: Purchased_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Purchased_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_purchased_btn(inputs)
	if (locale === "ar") return ar_purchased_btn(inputs)
	if (locale === "de") return de_purchased_btn(inputs)
	if (locale === "es") return es_purchased_btn(inputs)
	if (locale === "fr") return fr_purchased_btn(inputs)
	if (locale === "it") return it_purchased_btn(inputs)
	if (locale === "ja") return ja_purchased_btn(inputs)
	if (locale === "ko") return ko_purchased_btn(inputs)
	if (locale === "pt_br") return pt_br_purchased_btn(inputs)
	if (locale === "ru") return ru_purchased_btn(inputs)
	if (locale === "th") return th_purchased_btn(inputs)
	if (locale === "tr") return tr_purchased_btn(inputs)
	if (locale === "zh_cn") return zh_cn_purchased_btn(inputs)
	return zh_tw_purchased_btn(inputs)
});